import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios';

export const defaultJsonHeaders = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json'
};

export function createLocalizedClient(config: CreateAxiosDefaults = {}): AxiosInstance {
    const client = axios.create(config);

    client.interceptors.request.use((requestConfig) => {
        const lang = resolveLocale();
        if (lang) {
            requestConfig.headers = requestConfig.headers ?? {};
            requestConfig.headers['Accept-Language'] = lang;
        }

        return requestConfig;
    });

    return client;
}

function resolveLocale(): string | undefined {
    if (typeof document !== 'undefined') {
        const lang = document.documentElement.getAttribute('lang');
        if (lang) {
            return mapLocale(lang);
        }
    }

    if (typeof window !== 'undefined') {
        const stored = window.localStorage?.getItem('app.locale');
        if (stored) {
            return mapLocale(stored);
        }

        const browser = window.navigator.language;
        if (browser) {
            return mapLocale(browser);
        }
    }

    return undefined;
}

function mapLocale(value: string): string {
    if (value.toLowerCase().startsWith('nl')) {
        return 'nl';
    }

    return 'en';
}
